"use client";

import Image from "next/image";
import useUtility from "@/app/_hooks/useUtility";
import { frontendImage } from "@/lib/helpers";
import PageSkeleton from "../skeleton/PageSkeleton";
import { useSection } from "@/app/_partials/_sections/_hooks/useSection";
import CodeOfConductSkeleton from "../skeleton/CodeOfConductSkeleton";

export default function CodeOfConductPage() {
    const { trans } = useUtility();
    const { content, elements, loading } = useSection("code_conduct");

    if (loading) {
        return <CodeOfConductSkeleton />;
    }

    return (
    <section className="code-conduct-section section-bg">
        {/* Banner Top */}
        <div className="breadcrumb-banner-wrapper">
            <span className="code-conduct-shape one"></span>
            <span className="code-conduct-shape two"></span>
            <span className="code-conduct-shape three"></span>

            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xxl-10">
                        <div className="breadcrumb-banner two text-center pb-60">
                            <h3 className="breadcrumb-banner__title">
                                {trans(content?.title)}
                            </h3>
                            <p className="breadcrumb-banner__desc">
                                {trans(content?.description)}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Elements Section */}
        <div className="container">
            {elements?.map((item, idx) => {
                const isReversed = idx >= 2 && (idx - 2) % 2 === 0;
                const titleClass = `code-conduct-content__title${idx > 0 ? " text--warning" : ""}`;

                const imageElement = (
                    <div className="col-xl-5 col-md-6">
                        <div className={`code-conduct-thumb ${isReversed ? "two" : ""}`}>
                            <Image
                                src={frontendImage(item.image, "code_conduct")}
                                alt={trans(item.title)}
                                width={440}
                                height={440}
                            />
                        </div>
                    </div>
                );

                const contentElement = (
                    <div className="col-xl-7 col-md-6">
                        <div className="code-conduct-content">
                            <h2 className={titleClass}>{trans(item.title)}</h2>
                            <div
                                className="code-conduct-content__desc"
                                dangerouslySetInnerHTML={{
                                    __html: item.description || "",
                                }}
                            />
                        </div>
                    </div>
                );

                return (
                    <div
                        key={idx}
                        className={`row ${isReversed ? "flex-wrap-reverse" : ""} align-items-center gy-md-5 gy-4 code-conduct-row`}
                    >
                        {isReversed ? (
                            <>
                                {imageElement}
                                {contentElement}
                            </>
                        ) : (
                            <>
                                {contentElement}
                                {imageElement}
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    </section>
);

}
